import {atomWithReset} from 'jotai/utils'
import {EScene} from '../../../types/scene.types'

export const sceneState = atomWithReset<EScene>(EScene.INIT)
